var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "lf-simple-row-field" }, [
    _c(
      "div",
      { staticClass: "lf-simple-row-container" },
      [
        _c(_setup.Grid, {
          attrs: {
            gridConfiguration: _vm.rowConfiguration,
            itemData: _setup.itemData,
            toolbarOptions: _setup.toolbarOptions,
            allowPaging: false,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }